/*
	Author: xowei <wei@xowei.tw>
	Website: https://xowei.tw/
*/

$(function () {
	var $body = $('body, html')
	var $gototop = $('.hud--gototop')
	var $preload = $('.preload')
	var $window = $(window)
	var windowScroll = 0

	$gototop.hide()

	$window.on('scroll', function () {
		windowScroll = $(window).scrollTop()

		if (windowScroll < window.innerHeight) {
			if ($gototop.length) $gototop.hide()
		} else {
			if ($gototop.length) $gototop.show()
		}
	})

	$(window).load(function () {
		$preload.fadeOut()
		initAnimate()
	})

	smoothScroll('a[href^="#"]')
	smoothScroll('#gototop')
	initLazyLoadImage()
	initNavbarCollapse()
	initDetectDevice()
	initNav()
	initCarousel()
	initHashLink()
	initSectionModal()
})

function smoothScroll(target) {
	var $body = $('body, html')
	var $linkPosition
	var $nav = $('nav')

	$(target).each(function () {
		var $link = $(this)
		$linkPosition

		$link.on('click', function (e) {
			e.preventDefault()
			var tab = $link.attr('role')

			if (!tab) {
				var _href =$(this).attr('href')
				var $target = $(_href)
				$iconHeight = $('.product-title .icon').height()
				$linkPosition = ($target.length ? $target.offset().top : 0) - $nav.height()

				if ($target.is(':not(":first-child")')) {
					$linkPosition -= $iconHeight / 2
				}

				console.log('_href', _href)

				if (_href === '#kv') {
					console.log('hi')
					history.pushState("", document.title, window.location.pathname + window.location.search);
				}

				$body.animate({
					scrollTop: $linkPosition,
				})
			}
		})
	})
}

function initAnimate() {
	$('.section-title').attr("data-aos", "zoom-in")
	$('.section-carousel-text').attr("data-aos", "fade-up")
	$('.section-carousel-source').attr("data-aos", "fade-in")
	AOS.init({
		duration: 1000,
		// once: true,
	})
}

function initSvg() {
	$('.svg').each(function () {
		var $img = $(this)
		var imgID = $img.attr('id')
		var imgClass = $img.attr('class')
		var imgURL = $img.attr('src')
		// console.log($img)

		$.get(
			imgURL,
			function (data) {
				// console.log({
				// 	data,
				// })
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg')

				// Add replaced image's ID to the new SVG
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID)
				}
				// Add replaced image's classes to the new SVG
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg')
				}

				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a')

				// Replace image with new SVG
				$img.replaceWith($svg)
			},
			'xml',
		)
	})
}

function initLazyLoadImage() {
	!(function (window) {
		var $q = function (q, res) {
				if (document.querySelectorAll) {
					res = document.querySelectorAll(q)
				} else {
					var d = document,
						a = d.styleSheets[0] || d.createStyleSheet()
					a.addRule(q, 'f:b')
					for (var l = d.all, b = 0, c = [], f = l.length; b < f; b++) l[b].currentStyle.f && c.push(l[b])

					a.removeRule(0)
					res = c
				}
				return res
			},
			addEventListener = function (evt, fn) {
				window.addEventListener
					? this.addEventListener(evt, fn, false)
					: window.attachEvent
					? this.attachEvent('on' + evt, fn)
					: (this['on' + evt] = fn)
			},
			_has = function (obj, key) {
				return Object.prototype.hasOwnProperty.call(obj, key)
			}
		function loadImage(el, fn) {
			var img = new Image(),
				src = el.getAttribute('data-src')
			img.onload = function () {
				if (!!el.parent) el.parent.replaceChild(img, el)
				else el.src = src

				fn ? fn() : null
			}
			if (src) img.src = src
		}

		function elementInViewport(el) {
			var rect = el.getBoundingClientRect()
			// console.log(rect)

			return (
				rect.top >= 0 && rect.left >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 2
			)
		}

		var images = new Array(),
			query = $q('img'),
			processScroll = function () {
				for (var i = 0; i < images.length; i++) {
					if (elementInViewport(images[i])) {
						loadImage(images[i], function () {
							images.splice(i, i)
						})
					}
				}
			}
		for (var i = 0; i < query.length; i++) {
			images.push(query[i])
		}

		processScroll()
		addEventListener('scroll', processScroll)
	})(this)
}

function initDetectDevice() {
	var classNames = []
	if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)) classNames.push('device-ios')
	if (navigator.userAgent.match(/android/i)) classNames.push('device-android')
	if (navigator.userAgent.match(/Firefox/i)) classNames.push('device-firefox')
	if (navigator.userAgent.match(/Edg/i)) classNames.push('device-edge')
	if (navigator.userAgent.match(/Chrome/i)) classNames.push('device-chrome')

	var html = document.getElementsByTagName('html')[0]

	if (classNames.length) classNames.push('on-device')
	if (html.classList) html.classList.add.apply(html.classList, classNames)
}

function initNav() {
	$('.navbar a[href^="#"]:not(".dropdown-toggle")').on('click', function () {
		window.location.hash = $(this).attr('href')
		if ($(window).width() < 992) {
			$('.navbar-toggler').click()
		}
	})

	const collapse = document.querySelector('.navbar-collapse')
	const options = { attributes: true }

	function callback(mutationList, observer) {
		mutationList.forEach(function (mutation) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
				let showExist = $(mutation.target).hasClass('show')

				if ($(window).width() < 992) {
					if (showExist) {
						$('body').addClass('nav--open')
					} else {
						$('body').removeClass('nav--open')
					}
				}
			}
		})
	}

	if (!collapse) return

	const observer = new MutationObserver(callback)
	observer.observe(collapse, options)
}

function initCarousel() {
	$('.owl-carousel').each(function () {
		const _this = $(this)
		const { colorArrow = '#16365C', colorSwitcher, ...options } = _this.data('options')

		_this.owlCarousel({
			...options,
			navText: [
				`<img src="./images/icon/icon-arrow_left.png">`,
				`<img src="./images/icon/icon-arrow_right.png">`,
			],
		})

		_this.on({
			'changed.owl.carousel': (event) => {
				setTimeout(function () {
					const _tabs = $(colorSwitcher).find('.section-tabs-item')
					const _activeTab = _tabs.eq(event.page.index)
					const _items = _this.find('.owl-item')
					const _activeItem = _this.find('.owl-item.active').eq(1).prevObject
					const _srcs = _items.find('img, iframe')
					const _activeSrcs = _activeItem.find('img, iframe')

					_items.find('.aos-init').addClass('invisible').removeClass('aos-animate')
					_items.find('.section-paper').removeClass('active')

					setTimeout(() => {
						_activeItem.find('.aos-init').removeClass('invisible').addClass('aos-animate')
					}, 500)

					_tabs.removeClass('active')
					_activeTab.addClass('active')
					_activeItem.find('.section-paper').addClass('active')

					if (_srcs && _activeSrcs) {
						_srcs.each(function () {
							$(this).attr('src', '')
						})

						_activeSrcs.each(function () {
							$(this).attr('src', $(this).attr('data-src'))
						})
					}

					if ($(window).width() >= 768) return

					let _body = $('body, html')
					let pos = _this.parentsUntil('.section-wrapper').offset().top - $('.navbar').height()

					if (colorSwitcher) {
						let tabsHalfHeight = $(colorSwitcher).height() / 2
						pos = $(colorSwitcher).offset().top - $('.navbar').height() - tabsHalfHeight
					}

					_body.animate({
						scrollTop: pos,
					})
				}, 10)
			},
		})

		if (colorSwitcher) {
			// const _switcher = _this.parentsUntil('.product').find(colorSwitcher)
			const _item = $(colorSwitcher).children()

			// console.log(_item)

			_item
				.addClass('clickable')
				// .attr('style', 'cursor: pointer;')
				.on('click', function (event) {
					let index = _item.index(this)
					// let _body = $('body, html')
					// let pos = _this.parentsUntil('.section').find('.section-content').offset().top - $('.navbar').height()
					let _lazyImg = _this.find('img')
					// console.log('index', index)
					_this.trigger('to.owl.carousel', index)
					_this.trigger('stop.owl.autoplay')

					_lazyImg.each(function () {
						let src = $(this).attr('src')
						if (src) return
						$(this).attr('src', $(this).data('src'))
					})

					// if ($(window).width() >= 768) return

					// _body.animate({
					// 	scrollTop: pos,
					// })
				})
		}
	})
}

function initNavbarCollapse() {
	$('.navbar-toggler-icon.is-open').hide()

	$('.navbar-collapse').on('shown.bs.collapse', function () {
		$(this).parent().find('> .navbar-social').addClass('is-hide')
		$('.navbar-toggler-icon.is-collapse').hide()
		$('.navbar-toggler-icon.is-open').show()
	})

	$('.navbar-collapse').on('hidden.bs.collapse', function () {
		$(this).parent().find('> .navbar-social').removeClass('is-hide')
		$('.navbar-toggler-icon.is-collapse').show()
		$('.navbar-toggler-icon.is-open').hide()
	})
}

function initHashLink() {
	let navHeight = $('.navbar').height()
	let hash = location.hash

	if (!hash) return

	setTimeout(() => {
		window.scrollTo({ top: $(hash).offset().top - navHeight, behavior: 'instant' })
	}, 1000)
}

function initSectionModal() {
	let sectionModal = $('.section-modal .modal-body')

	$('.section-ticket-item-content .item').each(function () {
		let _item = $(this)
		let content = _item.find('.section-modal-content')

		_item.on('click', function () {
			sectionModal.html(content)
		})
	})
}

function Utils() {}

Utils.prototype = {
	constructor: Utils,
	isElementInView: function (element, fullyInView) {
		var pageTop = $(window).scrollTop()
		var pageBottom = pageTop + $(window).height()
		var elementTop = $(element).offset().top
		var elementBottom = elementTop + $(element).height()

		if (fullyInView === true) {
			return pageTop < elementTop && pageBottom > elementBottom
		} else {
			return elementTop <= pageBottom && elementBottom >= pageTop
		}
	},
	smoothScroll: function () {
		$('a[href^="#"]').on('click', function (e) {
			var $target = $(e.currentTarget.hash)

			$('html,body').animate(
				{
					scrollTop: $target.offset().top,
				},
				700,
			)

			e.preventDefault()
		})
	},
	detectViewport: function () {
		return { height: window.innerHeight, width: window.innerWidth }
	},
}
